import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnDestroy,
  Inject,
} from '@angular/core';
import { EntityService } from 'src/app/admin/core/services/entity.service';
import { EntiteDirective } from '../../../directives/entite.directives';
import { EntiteChamp } from '../../../entities/champ/entitechamp';
import { Subscription, filter, map } from 'rxjs';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DiaologHostComponent } from '../dialog-host/dialog-host';
import { ViewDto } from 'src/app/shared/entities/viewdto';
import { ViewService } from 'src/app/admin/core/services/viewservice';
import { Tables } from 'src/app/shared/entities/tables';
import { DynamicDocumentInfoService } from 'src/app/shared/services/dynamic-document-info.service';
import { DynamicDocumentInfo } from 'src/app/shared/entities/dynamic-document';
import { DynamicViewInfo } from 'src/app/shared/entities/dynamic-view';
import { DynamicViewInfoService } from 'src/app/shared/services/dynamic-view-info.service';

@Component({
  selector: 'app-visualisation',
  templateUrl: './visualisation.component.html',
  styleUrls: ['./visualisation.component.css'],
})
export class VisualisationComponent implements OnInit, OnDestroy {
  @Input() tab: Tables = new Tables();
  @ViewChild(EntiteDirective, { static: true })
  entiteDirective: EntiteDirective;
  entiteChamps: EntiteChamp[] = [];
  nouveauxChamps: EntiteChamp[] = [];
  subscriptions: Subscription[] = [];
  selectedOption: boolean = false; // public
  viewdto: ViewDto = new ViewDto();

  get invalidForm() {
    return !this.viewdto.nom || this.nouveauxChamps.length == 0;
  }

  constructor(
    private entiteService: EntityService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<DiaologHostComponent>,
    private viewSercice: ViewService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dynamicDocumentInfoService: DynamicDocumentInfoService,
    private dynamicViewInfoService: DynamicViewInfoService
  ) { }

  ngOnInit(): void {
    this.selectedOption = this.viewdto.shared;
    this.getChamps(this.tab.entite);
    this.dialogRef.updateSize(undefined, '90%');
  }
  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes['tab']) {
  //     this.tab = changes['tab'].currentValue;
  //     this.viewdto = this.tab.view;
  //     this.selectedOption = this.viewdto.shared;
  //     this.getChamps(this.tab.entite);
  //   }
  // }

  ngOnDestroy() {
    this.subscriptions.forEach((element) => {
      element.unsubscribe();
    });
  }
  async getChamps(entite: string) {

    if (this.tab.isDynamic) {
      this.dynamicDocumentInfoService
        .findByDocumentName(this.tab.entite)
        .pipe(
          map((el) => {
            if (el) this.entiteChamps = this.setFields(el);
            this.loadExistingFields();
          })
        )
        .subscribe();
    } else {
      try {
        const result = await this.entiteService.recouperChampsdEntite(entite);
        const resultCopy = JSON.parse(JSON.stringify(result));
        this.entiteChamps = resultCopy;

        this.loadExistingFields();
      } catch (error) {
        console.error('Error getting entity fields:', error);
      }
    }
  }

  loadExistingFields() {
    if (this.tab.view !== undefined) {
      this.viewdto = this.tab.view;
      this.selectedOption = !this.viewdto.isPrivate ?? false;


      const nouveauxChampsArr = Object.values(this.viewdto.champs);

      if (nouveauxChampsArr !== undefined) {
        nouveauxChampsArr.forEach((x) => {
          this.ajouterauVisusation(x);
        });
      }
    } else {
      this.viewdto = new ViewDto();
      this.viewdto.nom = '';
    }
  }

  setFields(el: DynamicDocumentInfo): EntiteChamp[] {
    let res: EntiteChamp[] = [];
    for (let i = 0; i < el.fields.length; i++) {
      let f = el.fields[i];
      let entityField: EntiteChamp = new EntiteChamp();
      entityField.label = {
        fr_FR: this.dynamicDocumentInfoService.getFieldLabel(f),
      };
      entityField.nom = f.name;
      entityField.type = f.type;
      entityField.modificateur = 2;

      res.push(entityField);
    }
    return res;
  }

  // getChamps(entite: string) {
  //   let sub = this.entiteService
  //     .recouperChampsdEntite(entite)
  //     .subscribe((res) => {
  //       let result = JSON.parse(JSON.stringify(res));
  //       this.entiteChamps = result;
  //       if (this.tab.view !== undefined) {
  //         this.viewdto = this.tab.view;
  //         let nouveauxChampsArr = Object.values(this.viewdto.champs);
  //         if (nouveauxChampsArr !== undefined) {
  //           nouveauxChampsArr.forEach((x) => {
  //             this.ajouterauVisusation(x);
  //           });
  //         }
  //       } else {
  //         this.viewdto.nom = '';
  //       }
  //     });

  //   this.subscriptions.push(sub);
  // }

  ajouterauVisusation(cham: string) {
    // console.log(this.entiteChamps);
    if (this.entiteChamps) {
      let sele = this.entiteChamps?.find((x) => x.nom === cham);
      let dejaAjouter = this.nouveauxChamps?.find((x) => x.nom === cham);
      if (sele && !dejaAjouter) {
        this.nouveauxChamps?.push(sele);
      }
      this.entiteChamps = this.entiteChamps?.filter((x) => x.nom !== cham);
    }
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  ouvrirFiltrePredefinis() {
    this.tab.dialogName = 'filterpredefini';
    this.tab.view = this.viewdto;

    let dialogRef = this.dialog.open(DiaologHostComponent, {
      panelClass: 'filtre-dialog-component',
      data: {
        title: 'Filtres prédéfinis',
        msg: ``,
        dialogName: 'filterpredefini',
        tab: this.tab,
        nouveauxChamps: this.nouveauxChamps,
        filterTypes: this.tab.filterTypes,
      },
    });

    dialogRef.afterClosed().subscribe((response: any) => {

      // Si response == undefined, c'est que l'utilisateur a cliqué sur retour ou sur la croix pour fermer la popup
      if (response || response === null) {
        this.viewdto.filter = response;
        // si response == null, c'est que l'utilisateur souhaite effacer tous les filtres
        this.enregistrer();
      } else {
        // this.viewdto.filter = response;
      }
    });
  }

  enregistrer() {

    this.viewdto.champs = new Map();
    this.nouveauxChamps.forEach((obj, index) => {
      this.viewdto.champs.set(index, obj.nom);
    });
    this.viewdto.champs = Object.fromEntries(this.viewdto.champs);
    this.viewdto.labels = this.loadLabels();
    this.viewdto.ownerid = localStorage.getItem('userid');
    this.viewdto.type = this.tab.title;
    this.viewdto.entite = this.tab.entite;
    this.viewdto.shared = this.selectedOption;
    this.viewdto.isPrivate = !this.selectedOption;
  
   
    if (this.tab.isDynamic) {
      let dynamicViewInfo = new DynamicViewInfo();
      dynamicViewInfo.id = this.viewdto.id;
      dynamicViewInfo.viewName = this.viewdto.nom;
      dynamicViewInfo.documentName = this.viewdto.entite;
      dynamicViewInfo.documentFields = Object.values(this.viewdto.champs);
      dynamicViewInfo.documentFieldsLabel = Object.values(this.viewdto.labels);
      dynamicViewInfo.filters = this.viewdto.filter; // A MODIFIER
      dynamicViewInfo.sorts = new Map(); // A MODIFIER
      dynamicViewInfo.isPrivate = this.viewdto.isPrivate;
      dynamicViewInfo.ownerId = this.viewdto.ownerid;

      this.dynamicViewInfoService.saveView(dynamicViewInfo).then((viewInfo) => {
        if (!dynamicViewInfo.id) {
          dynamicViewInfo.id = viewInfo.id;
        }
        let viewDto = this.transFormViewInfoToViewDto(dynamicViewInfo);
        this.viewSercice.updateView(viewDto);
      });
    } else {
      let url = '/view/add';
      this.viewdto?.filter?.forEach((filterItem) => {
        filterItem?.conditions?.forEach((condition: any) => {
          condition['type'] && (delete condition.type)
        });
      });

      this.entiteService.enregistrerView(this.viewdto, url).subscribe((res) => {
        this.viewSercice.updateView(res);
      });
    }

    this.dialogRef.close(this.viewdto);
  }

  transFormViewInfoToViewDto(viewInfo: DynamicViewInfo): ViewDto {
    const view: ViewDto = new ViewDto();
    view.id = viewInfo.id;
    view.nom = viewInfo.viewName;
    view.entite = this.tab.entite;
    view.isfavori = false;
    view.ownerid = viewInfo.ownerId;
    view.isselected = false;
    view.filter = viewInfo.filters;
    view.isPrivate = viewInfo.isPrivate;

    const champs: any = [];
    viewInfo.documentFields?.forEach((field: string) => {
      champs.push(field);
    });
    view.champs = champs;

    const labels: any = [];
    viewInfo.documentFieldsLabel?.forEach((field: string) => {
      labels.push(field);
    });
    view.labels = labels;
    return view;
  }
  loadLabels() {
    let champsArray = Object.values(this.viewdto.champs);
    let labels = new Map();
    champsArray.forEach((obj: any, index: number) => {
      let lab = this.nouveauxChamps.find((el) => el?.nom == obj)?.label.fr_FR;
      labels.set(index, lab);
    });
    labels = Object.fromEntries(labels);
    return labels;
  }

  annuler() {
    this.dialog.closeAll();
  }
}
